module.exports = "build/assets/RingsideWide-Semi.9b600388.woff";